import { render, staticRenderFns } from "./Finished.vue?vue&type=template&id=1c004072&scoped=true&"
import script from "@/views/Users/Student/Finished.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/Finished.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/finished.scss?vue&type=style&index=0&id=1c004072&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c004072",
  null
  
)

export default component.exports